import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@core/services/authentication/auth.service';
import { isRenaultApp } from '@core/utils/apps.utils';

@Injectable({
  providedIn: 'root',
})
export class SignedGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return isRenaultApp() || this.authService.isLogged() || this.router.parseUrl('/login');
  }
}
